import React, { useState, useEffect } from "react";
import "./ProductImageGallery.css";

const ProductImageGallery = ({ product }) => {
  const [activeImage, setActiveImage] = useState("");

  useEffect(() => {
    if (product && product.gallery && product.gallery.length > 0) {
      setActiveImage(product.gallery[0]);
    }
  }, [product]);

  if (!product || !product.gallery) return null;

  return (
    <div className="product-image-container">
      {/* Thumbnails */}
      <div className="product-thumbnails">
        {product.gallery.map((imgUrl, index) => (
          <div
            key={index}
            className={`thumbnail-item ${activeImage === imgUrl ? "active" : ""}`}
            onMouseEnter={() => setActiveImage(imgUrl)}
            onClick={() => setActiveImage(imgUrl)}
          >
            <img src={imgUrl} alt={`Thumbnail ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Main Large Image */}
      <div className="product-main-image">
        <img src={activeImage} alt={product.fullTitle} />
      </div>
    </div>
  );
};

export default ProductImageGallery;
